import { useMemo } from 'react';
import { UserRoleEnum } from '../types';
import { useUser } from './useUser';

// OP-3222: free demo accounts. Regular users in an account with isDemo set (Super Admin → Accounts)
// only get the Programs page, with no side menu.

export const DEMO_LANDING_PATH = '/lessons?tab=programs';

// Route patterns (as declared in AuthGate) a demo user may open; everything else redirects to DEMO_LANDING_PATH.
// Program lessons open in a modal on /program/:id, so the unit-by-URL routes (/:id, /:id/:id) stay blocked:
// they would load any unit by its unique name, not just the ones in the demo program.
export const DEMO_ALLOWED_ROUTES = ['/lessons', '/program/:id'];

type DemoCheckUser = {
  role?: string | null;
  customer?: { isDemo?: boolean | null } | null;
} | null | undefined;

export const isDemoAccountUser = (user: DemoCheckUser): boolean =>
  !!user?.customer?.isDemo && user?.role === UserRoleEnum.User;

export const useIsDemoAccount = (): boolean => {
  const [user] = useUser();
  return useMemo(() => isDemoAccountUser(user), [user?.role, user?.customer?.isDemo]);
};
